import { CHART_TEXT } from '../constants';

interface TooltipFormatterContext {
	date: string;
	count: number;
}

export const createTooltipContent = (date: string, count: number): string => {
	return `${CHART_TEXT.TOOLTIP.COUNT_LABEL} ${count}<br/> ${CHART_TEXT.TOOLTIP.DATE_LABEL} ${date}`;
};

export function tooltipFormatter(): string {
	if (this != null) {
		const point = this as TooltipFormatterContext;
		return createTooltipContent(point.date, point.count);
	}

	return '';
}
